import { doCalc15MinutesReminder } from '@entities/schedules/schedule/helpers.tsx';
import addMinutes from 'date-fns/addMinutes';
import type React from 'react';

type SessionType = React.MutableRefObject<any>;
export const getYCoord = (sessionRef: SessionType) => sessionRef.current.y;
export const isYMoreThanNeed = (sessionRef: SessionType, windowWidth?: number) =>
  windowWidth && windowWidth <= 930 ? getYCoord(sessionRef) < 201.5 : getYCoord(sessionRef) < 178.5;
// const isNeedToCutCursor = (sessionRef: SessionType) =>
//   isYMoreThanNeed(sessionRef) && sessionRef.current.action === 'remove';

export const calcHeight = (sessionRef: SessionType, windowWidth: number) => {
  let height = 0;
  const duration = sessionRef.current.duration;
  const sessionStart = sessionRef.current.start;

  const startReminder = doCalc15MinutesReminder(sessionStart);

  const durationInTimeSlots = Math.floor(duration / 15);
  const durationIn5MinSlots = Math.floor(sessionRef.current.duration / 5);

  if (sessionRef.current.part === 'full') {
    const isOverlapping = sessionRef.current.isOverlapping;
    let plusEnd = 0;

    const sessionEnd = addMinutes(sessionStart, duration);
    const endReminder = doCalc15MinutesReminder(sessionEnd);

    const plusStart = startReminder !== 0 && !isOverlapping ? 10 : 0;

    switch (endReminder - startReminder) {
      case 0: {
        (startReminder === 5 && endReminder === 5 && duration > 15 && (plusEnd += 10)) ||
          (startReminder === 10 && endReminder === 10 && duration > 15 && (plusEnd += 10));

        // console.log('0');
        // if (startReminder === 5) {
        //   console.log('startReminder', 5);
        // }
        // if (startReminder === 10) {
        //   console.log('startReminder', 10);
        // }
        // if (endReminder === 5) {
        //   console.log('endReminder', 5);
        // }
        // if (endReminder === 10) {
        //   console.log('endReminder', 10);
        // }
        break;
      }
      case 5: {
        (startReminder === 5 && endReminder === 10 && duration > 30 && (plusEnd += 20)) ||
          (startReminder === 5 && endReminder === 10 && (plusEnd += 10)) ||
          (endReminder === 5 && (plusEnd += 20));

        // console.log('5');
        // if (startReminder === 5) {
        //   console.log('startReminder', 5);
        // }
        // if (startReminder === 10) {
        //   console.log('startReminder', 10);
        // }
        // if (endReminder === 5) {
        //   plusEnd += 20;
        //   console.log('endReminder', 5);
        // }
        // if (endReminder === 10) {
        //   console.log('endReminder', 10);
        // }
        break;
      }
      case 10: {
        endReminder === 10 && (plusEnd += 34);

        // console.log('10');
        // if (startReminder === 5) {
        //   console.log('startReminder', 5);
        // }
        // if (startReminder === 10) {
        //   console.log('startReminder', 10);
        // }
        // if (endReminder === 5) {
        //   console.log('endReminder', 5);
        // }
        // if (endReminder === 10) {
        //   console.log('endReminder', 10);
        // }
        break;
      }
      case -5: {
        (startReminder === 5 && duration > 30 && (plusEnd += 30)) ||
          (startReminder === 5 && (plusEnd += 20)) ||
          (startReminder === 10 && endReminder === 5 && duration > 30 && (plusEnd += 46)) ||
          (startReminder === 10 && endReminder === 5 && (plusEnd += 36));

        // console.log('-5');
        // if (startReminder === 5) {
        //   console.log('startReminder', 5);
        // }
        // if (startReminder === 10) {
        //   console.log('startReminder', 10);
        // }
        // if (endReminder === 5) {
        //   console.log('endReminder', 5);
        // }
        // if (endReminder === 10) {
        //   console.log('endReminder', 10);
        // }
        break;
      }
      case -10: {
        (startReminder === 10 && duration > 30 && (plusEnd += 22.6)) ||
          (startReminder === 10 && (plusEnd += 12));

        // console.log('-10');
        // if (startReminder === 5) {
        //   console.log('startReminder', 5);
        // }
        // if (startReminder === 10) {
        //   console.log('startReminder', 10);
        // }
        // if (endReminder === 5) {
        //   console.log('endReminder', 5);
        // }
        // if (endReminder === 10) {
        //   console.log('endReminder', 10);
        // }
        break;
      }
    }
    height =
      durationInTimeSlots === 1
        ? 34 + plusStart + plusEnd
        : 10 * (durationInTimeSlots - 1) + 34 * durationInTimeSlots + plusEnd;
  }

  if (sessionRef.current.part === 'start') {
    // console.log('startReminder:', startReminder);
    // console.log('duration:',duration);
    let plusEndStart = 1;
    startReminder === 5 && (plusEndStart = 9);
    startReminder === 10 && (plusEndStart = 11);
    height =
      durationIn5MinSlots <= 3
        ? 34
        : 11 * (durationInTimeSlots - 1) + 11 * durationIn5MinSlots + plusEndStart;
  }

  if (sessionRef.current.part === 'end') {
    const endReminder = duration % 15;
    let plusEnd = 1;
    // console.log('endReminder:', endReminder);
    endReminder === 5 && (plusEnd = 14);
    endReminder === 10 && (plusEnd = 11);
    const endHeight = 11 * durationIn5MinSlots;
    height =
      durationInTimeSlots < 1 ? endHeight : 11 * (durationInTimeSlots - 1) + endHeight + plusEnd;
  }

  isYMoreThanNeed(sessionRef) &&
    (height -= 168 - getYCoord(sessionRef)) &&
    windowWidth <= 930 &&
    (height -= 30);

  return height;
};
export const calcTop = (sessionRef: SessionType, windowWidth: number) => {
  let top = getYCoord(sessionRef);
  isYMoreThanNeed(sessionRef, windowWidth) && (top = 168) && windowWidth <= 930 && (top += 30);
  return top;
};
